"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analyticsQuickViewUpdated = exports.analyticsQuickViewOpened = exports.analyticsQuickViewEmailMe = exports.analyticsQuickViewClosed = exports.analyticsAddToBasketSuccess = void 0;
var _analytics = require("../../constants/analytics");
var _productHelpers = require("./../productHelpers");
var _analyticsHelpers = require("./analyticsHelpers");
var _transformAnalyticsData = require("./transformAnalyticsData");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var analyticsAddToBasketSuccess = exports.analyticsAddToBasketSuccess = function analyticsAddToBasketSuccess(_ref) {
  var id = _ref.id,
    skuId = _ref.skuId,
    product = _ref.product,
    _ref$extraData = _ref.extraData,
    extraData = _ref$extraData === void 0 ? {} : _ref$extraData;
  var _product$skus = product.skus,
    skus = _product$skus === void 0 ? [] : _product$skus,
    promotionClassifications = product.promotionClassifications;
  try {
    var skuAdded = (0, _productHelpers.findSkuBy)({
      id: skuId
    }, {
      skus: skus
    });
    var productExtraData = extraData.product,
      eventExtraData = extraData.event;
    if (promotionClassifications !== null && promotionClassifications !== void 0 && promotionClassifications.length) {
      productExtraData.promotionClassifications = promotionClassifications;
    }
    var data = (0, _transformAnalyticsData.transformAnalyticsBasketData)({
      skuAdded: skuAdded,
      productId: id
    });
    (0, _analyticsHelpers.setJlDataAndDispatchEvent)({
      data: data,
      eventData: _objectSpread(_objectSpread({}, eventExtraData), {}, {
        action: _analytics.ANALYTICS_DATALAYER_EVENTS.ADD_TO_BASKET_SUCCESS,
        type: 'quickview',
        product: (0, _transformAnalyticsData.formatBasketProductData)({
          skuAdded: skuAdded,
          productId: id,
          extraData: productExtraData
        })
      })
    });
  } catch (error) {
    console.error('analyticsAddToBasketSuccess event error', error);
  }
};
var analyticsQuickViewUpdated = exports.analyticsQuickViewUpdated = function analyticsQuickViewUpdated(product) {
  var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  try {
    var productExtraData = extraData.product,
      eventExtraData = extraData.event;
    var data = (0, _transformAnalyticsData.transformAnalyticsData)(product, productExtraData);
    (0, _analyticsHelpers.setJlDataAndDispatchEvent)({
      data: data,
      eventData: _objectSpread(_objectSpread({}, eventExtraData), {}, {
        action: _analytics.ANALYTICS_DATALAYER_EVENTS.QUICK_VIEW_UPDATED
      })
    });
  } catch (error) {
    console.error('analyticsQuickViewUpdated event error', error);
  }
};
var analyticsQuickViewOpened = exports.analyticsQuickViewOpened = function analyticsQuickViewOpened(product) {
  var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  try {
    var productExtraData = extraData.product,
      eventExtraData = extraData.event,
      additionalInfo = extraData.additionalInfo;
    var data = (0, _transformAnalyticsData.transformAnalyticsData)(product, productExtraData);
    var _data$data = data.data,
      _data$data2 = _data$data === void 0 ? {} : _data$data,
      transformedProduct = _data$data2.quickView;
    (0, _analyticsHelpers.setJlDataAndDispatchEvent)({
      data: data,
      eventData: _objectSpread(_objectSpread({}, eventExtraData), {}, {
        action: _analytics.ANALYTICS_DATALAYER_EVENTS.QUICK_VIEW_OPENED,
        product: transformedProduct,
        additionalInfo: additionalInfo
      })
    });
  } catch (error) {
    console.error('analyticsQuickViewOpened event error', error);
  }
};
var analyticsQuickViewEmailMe = exports.analyticsQuickViewEmailMe = function analyticsQuickViewEmailMe() {
  var extraData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isFutureRelease = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  try {
    var eventExtraData = extraData.event,
      productId = extraData.productId;
    (0, _analyticsHelpers.dispatchAnalyticsEvent)(_objectSpread(_objectSpread({}, eventExtraData), {}, {
      action: isFutureRelease ? _analytics.ANALYTICS_DATALAYER_EVENTS.EMAIL_PRODUCT_LAUNCH : _analytics.ANALYTICS_DATALAYER_EVENTS.EMAIL_BACK_IN_STOCK,
      productId: productId
    }));
  } catch (error) {
    console.error('analyticsQuickViewEmailMe event error', error);
  }
};
var analyticsQuickViewClosed = exports.analyticsQuickViewClosed = function analyticsQuickViewClosed() {
  var sectionsToUnset = {
    quickView: true
  };
  (0, _analyticsHelpers.unsetJlDataSections)({
    sectionsToUnset: sectionsToUnset
  });
};